import { useHubContext } from '../../shell/HubContext';
import { Composer } from './Composer';

/** The section's entry point: pulls what `Composer` needs from the hub shell's shared context. */
export function OnboardingEmailSection() {
  const { api, draftUnavailableReason, onConsentRequired } = useHubContext();

  return (
    <Composer api={api} draftUnavailableReason={draftUnavailableReason} onConsentRequired={onConsentRequired} />
  );
}
